import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Element } from 'react-scroll';        // ✅ Correct import
import { flowRight as compose } from 'lodash';

import Loader from '../../components/Loader';

import WhyHostBanner from './WhyHostBanner';
import HostingBlock from '../../components/WhyHost/HostingBlock/HostingBlock';
import CoverSection from '../../components/WhyHost/CoverSection/CoverSection';
import ImageBanner from '../../components/WhyHost/ImageBanner/ImageBanner';
import PaymentContent from '../../components/WhyHost/PaymentContent/PaymentContent';
import QuoteSection from '../../components/WhyHost/QuoteSection/QuoteSection';
import FaqSection from '../../components/WhyHost/FaqSection/FaqSection';

import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import getWhyHostReview from './getWhyHostReview.graphql';
import { withQuery } from '../../hoc/withGraphql';

import s from './WhyHostNew.css';

const WhyHostNew = (props) => {

    const {
        data: { loading, getWhyHostPage },
        getWhyHostReview: {
            loading: reviewLoading,
            getHomeWhyHostReview
        }
    } = props;

    if (loading || reviewLoading) {
        return <Loader type="text" loaderClass="whyHostLoaderContainer" />;
    }

    // Convert array → object
    const settingsCollection = {};
    getWhyHostPage?.forEach(item => {
        settingsCollection[item.name] = item.value;
    });

    return (
        <div className={cx('whyhost-content', 'commonWordBreak')}>
            <WhyHostBanner data={settingsCollection} />

            <Element name="whyhost-sections" className="element">
                <HostingBlock data={settingsCollection} />
                <CoverSection data={settingsCollection} />
                <ImageBanner data={settingsCollection} />

                {getHomeWhyHostReview?.results?.length > 0 && (
                    <PaymentContent
                        data={settingsCollection}
                        reviewData={getHomeWhyHostReview.results}
                    />
                )}

                <QuoteSection data={settingsCollection} />
                <FaqSection data={settingsCollection} />
            </Element>
        </div>
    );
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: { fetchPolicy: 'network-only', ssr: false }
    }),
    withQuery(getWhyHostReview, {
        name: 'getWhyHostReview',
        options: { fetchPolicy: 'network-only', ssr: false }
    })
)(WhyHostNew);
